import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../_metronic/helpers';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import fetchAPI from "../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import { dropDownSelectionStyles, getValueFromResource } from '../../common/timeLiveFunction';
import { getClientDatatableAsync, setFilters, resetFiltersState } from './AccountClientSlice';

const AccountClientFilters = (props: any) => {
    const { modelRef, t } = props;
    const { maxMenuHeight } = useAppSelector(state => state.globalState);
    const dispatch = useAppDispatch();

    const { 
        pageSize, columnIndex, direction,
        filterClientName, filterClientNick, filterEmailAddress, filterCountryId, filterStatus 
    } = useAppSelector((state) => state.accountClient);

    const [clientName, setClientName] = useState<string>(filterClientName || '');
    const [clientNick, setClientNick] = useState<string>(filterClientNick || '');
    const [emailAddress, setEmailAddress] = useState<string>(filterEmailAddress || '');

    const [selectedOptionCountry, setSelectedOptionCountry] = useState<{ label: string; value: any } | null>(null);
    const [countryArray, SetCountryArray] = useState<any | ''>([]);

    const activeInActiveOptions = [
        { label: getValueFromResource('All', dispatch, t), value: -1 },
        { label: getValueFromResource('Active', dispatch, t), value: 0 },
        { label: getValueFromResource('InActive', dispatch, t), value: 1 }
    ];
    const [selectedOptionStatus, setSelectedOptionStatus] = useState<any>(
        activeInActiveOptions.find(item => item.value === filterStatus) || activeInActiveOptions[0]
    ); 

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    const getCountryAsync = async () => {
        const response = await fetchAPI("api/ExpensePolicies/GetCountry", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.CountryId;
            item.label = item.Country;
            delete item.CountryId;
            delete item.Country;
        });
        json.unshift({ value: 0, label: 'Select' })
        SetCountryArray(json);
    }

    useEffect(() => {
        getCountryAsync();
    }, []);

    useEffect(() => {
        if (countryArray && countryArray.length > 0) {
            const targetCountryId = filterCountryId !== undefined ? filterCountryId : 0;
            const savedIndex = countryArray.findIndex((item: any) => Number(item.value) === Number(targetCountryId));
            if (savedIndex !== -1) {            
                setSelectedOptionCountry(countryArray[savedIndex]);
            } else {
                setSelectedOptionCountry(countryArray[0]);
            }
        }
    }, [countryArray, filterCountryId]); 

    const handleSubmit = () => {   
        const selectedCountryVal = selectedOptionCountry?.value ?? 0;
        const selectedStatusVal = selectedOptionStatus?.value ?? -1;

        const filterData = {
            ClientName: clientName || "",
            ClientNick: clientNick || "",
            EmailAddress: emailAddress || "",
            CountryId: Number(selectedCountryVal),
            IsDisabled: Number(selectedStatusVal)
        };

        dispatch(setFilters(filterData));

        const payload = {
            currentPage: 1, 
            pageSize: pageSize ?? 10,
            start: 0,
            order: columnIndex ?? 0,
            orderDir: direction ?? "asc",
            search: " ",
            ...filterData
        };
       
        dispatch(getClientDatatableAsync(payload));

        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }

    const handleChangeCountry = (selectedOption: any) => {
        setSelectedOptionCountry(selectedOption);
    }

    const handleChangeStatus = (selectedOption: any) => {
        setSelectedOptionStatus(selectedOption);
    };

    const handleReset = () => {
        setClientName('');
        setClientNick('');
        setEmailAddress('');
        
        const defaultCountry = countryArray.find((item: any) => item.value === '0' || item.value === 0);
        setSelectedOptionCountry(defaultCountry || null);
        setSelectedOptionStatus(activeInActiveOptions[0]);
        dispatch(resetFiltersState());

        const resetPayload = {
            currentPage: 1, 
            pageSize: pageSize ?? 10,
            start: 0,
            order: columnIndex ?? 0,
            orderDir: direction ?? "asc",
            search: " ",
            ClientName: "",
            ClientNick: "",
            EmailAddress: "",
            CountryId: 0,
            IsDisabled: -1
        };

        dispatch(getClientDatatableAsync(resetPayload));
        
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }

    return (
        <>
            <div className='card-body' style={{ overflowY: 'auto' }}>
                <div className="col-md-12 mb-4">
                    <label className="fs-7 fw-normal mb-2">
                        {getValueFromResource('Client Name', dispatch, t)}
                    </label>
                    <input
                        type="text"
                        className="form-control fs-7 fw-normal"
                        placeholder={getValueFromResource('Enter Client Name', dispatch, t)}
                        value={clientName}
                        onChange={(e) => setClientName(e.target.value)}
                    />
                </div>

                <div className='row spacingBetweenRows mb-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {getValueFromResource('Client Nick', dispatch, t)}
                        </label>
                        <input
                            type="text"
                            className="form-control fs-7 fw-normal"
                            placeholder={getValueFromResource('Enter Client Nick', dispatch, t)}
                            value={clientNick}
                            onChange={(e) => setClientNick(e.target.value)}
                        />
                    </div>
                </div>

                <div className='row spacingBetweenRows mb-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {getValueFromResource('Email Address', dispatch, t)}
                        </label>
                        <input
                            type="email"
                            className="form-control fs-7 fw-normal"
                            placeholder={getValueFromResource('Enter Email Address', dispatch, t)}
                            value={emailAddress}
                            onChange={(e) => setEmailAddress(e.target.value)}
                        />
                    </div>
                </div>

                <div className='row spacingBetweenRows mb-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {getValueFromResource('Country', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionCountry}
                            id="CountryId"
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="CountryId"                                                 
                            onChange={handleChangeCountry}
                            options={countryArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>

                <div className='row spacingBetweenRows mb-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {getValueFromResource('Status', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionStatus}
                            id="IsDisabled"
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="IsDisabled"
                            onChange={handleChangeStatus}
                            options={activeInActiveOptions}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
            </div>

         <div className='card-footer pt-4'>
    <div className='d-flex flex-stack float-end'>
        <button
            type="button"
              className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
            onClick={() => handleReset()}
        >
            {getValueFromResource('Reset Filters', dispatch, t)}
        </button>       
        <button
            ref={closeButtonRef}
            type="button"
            className="d-none"
            id='kt_OffCanvas_close'
        >
            Cancel
        </button>
        <button
            type="button"
            data-kt-element='send'
            className="btn btn-primary btn-sm fs-7"
            onClick={() => handleSubmit()}
        ><i className="bi bi-filter fs-5 me-1"></i>
            {getValueFromResource('Apply Filters', dispatch, t)}
        </button>
    </div>
</div>
        </>
    )
}

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}

export default AccountClientFilters;